<template>
  <BaseInput
    v-bind="$attrs"
    @input="updateInput($event.target.value)"
  />
</template>

<script setup lang="ts">
import BaseInput from '~/base/components/input/Input.vue'

const emits = defineEmits(['update:modelValue', 'submit'])

const updateInput = (inputVal: string) => {
  emits('update:modelValue', inputVal)
}
</script>
